import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../helpers";

const STEPS = ["Discover", "Strategy", "Design", "Development", "Testing", "Deployment", "Launch"];

export default function ProcessTimeline() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const width = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section className="relative py-28 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-brand-orange uppercase mb-4">/ Process</p>
          <h2 className="font-heading font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl">
            From idea to <span className="text-gradient-orange">launch</span>
          </h2>
        </Reveal>

        <div className="mt-20 relative">
          {/* base line */}
          <div className="absolute top-5 left-0 right-0 h-px bg-white/10 hidden md:block" />
          <motion.div
            style={{ width }}
            className="absolute top-5 left-0 h-px hidden md:block"
          >
            <div className="h-full w-full" style={{ background: "linear-gradient(to right,#FF5F00,#FFC400)", boxShadow: "0 0 12px #FF8A00" }} />
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-7 gap-8 md:gap-4">
            {STEPS.map((s, i) => (
              <Reveal key={s} delay={i * 0.06} className="relative">
                <div className="flex md:flex-col items-center md:items-start gap-4 md:gap-0">
                  <div className="relative z-10 h-10 w-10 rounded-full glass border border-brand-orange/40 flex items-center justify-center font-mono text-sm text-brand-orange shrink-0">
                    {i + 1}
                  </div>
                  <p className="md:mt-6 font-heading font-medium text-base md:text-lg">{s}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
